$(document).ready(function() {

    /*******************************************/
    //Form Validation
    $('.validate-form').each(function() {
        $(this).validate({
            submitHandler: function(form) {
                form.submit();
            },
            rules: {
                required: true
            },
            errorPlacement: function(error, element) {
                error.appendTo(element.closest('.form-field'));
            },
            highlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').addClass(errorClass).removeClass(validClass);
                } else if (element.type === 'select') {
                    this.findByName(element.name).closest('.form-field').addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
                }
            },
            unhighlight: function(element, errorClass, validClass) {
                if (element.type === 'radio') {
                    this.findByName(element.name).parents('.form-field').removeClass(errorClass).addClass(validClass);
                } else if (element.type === 'select') {
                    this.findByName(element.name).closest('.form-field').removeClass(errorClass).addClass(validClass);
                } else {
                    $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
                }
            }
        });
    });

    /*******************************************/
    //[Be] Lazy Image Loading
    $(function() {
        // Initialize
        var bLazy = new Blazy({
            loadInvisible: true,
            offset: 500
        });
    });
    //[Be] Lazy Image Loading in container
    $(function() {
        // Initialize
        var bLazy = new Blazy({
            selector: '.b-lazy-dektop',
            offset: 500
        });
    });
    //[Be] Lazy Image Loading Responsive - Used on the badge page tiles BG images
    $(function() {
        var bLazy = new Blazy({
            selector: '.b-lazy-responsive',
            offset: 500,
            breakpoints: [{
                width: 1023,
                src: 'data-src-small'
             }]
        });
    });

    /*******************************************/
    //Custom Select Dropdown
    $(function() {
        $('.custom-select-dropdown').selectric();
    });

    /*******************************************/
    //Lightbox Initiations
    $('.open-popup-link').magnificPopup({
        type:'inline',
        showCloseBtn: true,
        closeOnBgClick: true,
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        midClick: true
    });
    //Lightbox Initiations
    $('.open-youtube-link').magnificPopup({
        type:'inline',
        showCloseBtn: true,
        closeOnBgClick: true,
        removalDelay: 300,
        mainClass: 'mfp-zoom-in',
        midClick: true
    });

    $('.lightbox-manual-close-trigger').click(function(event) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    /*******************************************/
    // Tabs
    $('.js-tab-triggers a').on('click', function(e) {
        e.preventDefault();
        $('.js-tab-triggers a').not(this).removeClass('active');
        $(this).addClass('active');
        var getTarget = $(this).attr('href');
        $('.tab-content').not(getTarget).hide();
        $(getTarget).show();
    });

    /*******************************************/

    $('.vehicles-dropdown-slideshow').slick({
        infinite: true,
        arrows: false,
        dots: true,
        speed: 600,
        autoplay: true,
        autoplaySpeed: 20000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1324, settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 1024, settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 480, settings: { slidesToShow: 3 }
            }
        ]
    });

        /*******************************************/



       /*******************************************/

       $('.select-model-slideshow').slick({
        infinite: true,
        arrows: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1030, settings: { slidesToShow: 3.1, infinite: false, arrows: false, centerMode: true, centerPadding: 0, }
            },
            {
                breakpoint: 834, settings: { slidesToShow: 2, infinite: false }
            },
            {
                breakpoint: 600, settings: { slidesToShow: 3.1, infinite: false, arrows: false, centerMode: true, centerPadding: 0, }
            }
        ]
    });

});


/*******************************************/
$.fn.toggleHTML = function(t1, t2) {
    if (this.html() == t1) this.html(t2);
    else this.html(t1);
    return this;
};


/*******************************************/
//Mobile Main Menu
function slideMenu(action){
    var $menu = $('#mobile-menu')
    if (!action) { toggle(); return }
    if (action == "open") { open(); return }
    if (action == "close") { close(); return }

    function open(){
        $("body").addClass('open-menu');
        $menu.attr('status', 'open');
    }
    function close(){
        $("body").removeClass('open-menu');
        $menu.attr('status', 'closed');
    }
    function toggle(){
        console.log('works-1');
        var status =  $menu.attr('status');
        if (status == "open"){ close(); return }
        console.log('works-2');
        if (status == "closed"){ open(); return }
        console.log('works-3');
    }
}

$('#mobile-menu li').each(function(){
        $(this).has("ul").addClass('mobile-menu-parent');
});

$( ".mobile-menu-parent .a" ).on("click", function(){
    $(this).siblings('ul').slideToggle(150);
});

//prevent slide up
$(".mobile-menu-parent").on("click", "ul", function(event){
    event.stopPropagation()
})

/*******************************************/
// Nav Dropdown and Inner Dropdown
function closeDropdownInner() {
    var prevEl = $('.secondary-level.slided')
    $(prevEl).slideUp(400, function(){
        $(prevEl).removeClass('slided');
    });
}

$('.nav-trigger').on('click', function(e){
    e.preventDefault();
    var destination = '.' + $(this).data('href');
    var dropdownFolder = $('.nav-dropdowns');

    var timeoutID;

    function delayedTransition() {
        timeoutID = window.setTimeout(function () {
            console.log('hhh');
            $(dropdownFolder).find('.nav-active').not(destination).removeClass('nav-active nav-current');
        }, 1000);
    }

    if ($(this).parent().hasClass('nav-active')) {
        $(this).parent().removeClass('nav-active');
    } else {
        $(this).parent().siblings().removeClass('nav-active');
        $(this).parent().addClass('nav-active');
    }

    if ($(destination).hasClass('nav-current')) {
        $(destination).removeClass('nav-current');
    } else if ($(dropdownFolder).children('.nav-dropdown').hasClass('nav-current')){
        $(destination).siblings('.nav-current').addClass('nav-active');
        $(destination).addClass('nav-current');
        delayedTransition();
    } else {
        $(destination).addClass('nav-current');
    }
    closeDropdownInner();
});

// $('.dropdown-item > a').on('click', function(e){
    // e.preventDefault();
    // var prevEl = $('.secondary-level.slided'),
    // targetEl = $(this).attr('class'),
    // thisEl = $(this);

    // function itemChange() {
    //     if($(thisEl).parent().hasClass('level-open')) {
    //         $(thisEl).parent().removeClass('level-open');
    //     } else {
    //         $(thisEl).parent().siblings('.dropdown-item').removeClass('level-open');
    //         $(thisEl).parent().addClass('level-open');
    //     }
    // }

    // if (targetEl === 'overlay' && $(this).parent().parent().hasClass('level-cover')) {
    //     itemChange();
    //     console.log('iner-link');
    // } else if (targetEl === 'overlay') {
    //     itemChange();
    //     closeDropdownInner();
    //     console.log('overlay');
    // } else if ($(targetEl).hasClass('slided')) {
    //     itemChange();
    //     $(targetEl).removeClass('slided');
    //     $(targetEl).slideUp(400);
    //     console.log('slide-up');
    // } else if ($(prevEl).length) {
    //     $(prevEl).slideUp(400, function(){
    //         itemChange();
    //         $(prevEl).removeClass('slided');
    //         $(targetEl).addClass('slided');
    //         $(targetEl).slideDown(400);
    //         console.log('slide-up-down');
    //     });
    // } else {
    //     itemChange();
    //     $(targetEl).addClass('slided');
    //     $(targetEl).slideDown(400);
    //     console.log('slide-down');
    // }

// });
/*******************************************/
// Header Highlighter
$(document).ready(function() {
    var headerHref = "#site-header";
    var mobileHref = "#mobile-menu";
    var myURL = "/" + location.pathname.split('/')[1];

    $(headerHref + ' li').each(function(){
        if ($(this).find('a').attr('href') == myURL) {
            $(this).find('a').addClass("selected")
            return
        }
    })

    $(mobileHref + ' li').each(function(){
        if ($(this).find('a').attr('href') == myURL) {
            $(this).find('a').addClass("selected")
            return
        }
    })
});

/*******************************************/
//Inner Page Nav

$('.js-inner-nav-ul .highlight a').on('click', function(e){
    var target = $(this).attr('href');

    e.preventDefault();

    $(this).parent().siblings().removeClass('active');
    $(this).parent().addClass('active');

    $('html, body').animate({
        scrollTop: ($(target).offset().top - 109)
    },500);
});

if ($('.js-page-inner-nav').length) {
    $(window).on('scroll', function(){
        var body = $('body'),
        scrollTop = $(window).scrollTop(),
        navOffset = $('.js-page-inner-nav').offset().top,
        currentNavOffset = (navOffset - scrollTop);

        if(currentNavOffset <= 49 && !body.hasClass('mini-nav'))
            body.addClass('mini-nav');
        else if(currentNavOffset >= 49 && body.hasClass('mini-nav'))
            body.removeClass('mini-nav');
    });
}

$(document).ready(function(){
    var section = $('body').find(".js-nav-section"),
    nav = $('body').find('.js-inner-nav ul'),
    didScroll = false,
    $window = $(window);

    $window.scroll(function() {
        didScroll = true;
    });

    setInterval(function() {
        if ( didScroll ) {
            didScroll = false;

            $(section).each(function(){
                var item = $(this),
                calc = (item.offset().top - $window.scrollTop()),
                id = item.attr('id');

                if( calc < 200 && calc > 0 && !item.hasClass('js-inview')) {
                    section.removeClass('js-inview');
                    item.addClass('js-inview');
                    nav.find('li').removeClass('active');
                    nav.find('a[href="#' + id + '"]').parent().addClass('active');
                }
            });
        }
        if ($window.scrollTop() < 200 && $window.scrollTop() >= 0) {
            section.removeClass('js-inview');
            nav.find('li').removeClass('active');
        }
    }, 250);
});

/*******************************************/
//Two tabbed Info Block

$('.switch-content button').on('click', function(){
    var container = $(this).closest('.two-tabbed-info'),
    textContainer = container.find('.text-block'),
    imageContainer = container.find('.image-container');

    if($(this).parent().hasClass('first')){
        container.removeClass('second');

        imageContainer.removeClass('second');

        textContainer.find('.first').slideDown();
        textContainer.find('.second').slideUp();
    } else {
        container.addClass('second');

        imageContainer.addClass('second');

        textContainer.find('.first').slideUp();
        textContainer.find('.second').slideDown();
    }

});

/*******************************************/
//Accordian

$('.js-accordian').on('click', '.js-header', function(){
    var accordian = $(this).parent('.js-accordian'),
    content = accordian.find('.js-content'),
    headers = accordian.find('.js-header');

    if(!$(this).hasClass('open')) {
        headers.removeClass('open');
        $(this).addClass('open');

        content.removeClass('open').slideUp();
        $(this).next('.js-content').addClass('open').slideDown(500,
            function() {
                var targetScroll = $(this).offset().top - 159;
                $('html, body').animate({
                    scrollTop: targetScroll
                },500)
            }
        );

        $(function() {
            // Initialize
            var bLazy = new Blazy({
                container: '.b-lazy-container',
                selector: 'img'
            });
        });

    } else {
        headers.removeClass('open');
        content.removeClass('open').slideUp();
    }
});

/*******************************************/
//Filter List and filter items
// $('body').on('click', '.js-filters li', function(){
//     var filter = $(this).data('filter'),
//     filterBlock = $(this).parent('.js-filters'),
//     container = $(this).closest('.js-filter-section'),
//     itemsContainer = container.find('.js-filter-items'),
//     items = itemsContainer.find('.js-item');

//     if ($(this).hasClass('active')) {
//         filterBlock.toggleClass('open');
//     } else if (filter == 'all') {
//         filterBlock.toggleClass('open');
//         items.show();
//         container.removeClass('filtered');
//     } else {
//         filterBlock.toggleClass('open');
//         container.addClass('filtered');
//         items.hide();
//         itemsContainer.children('.' + filter).show();
//     }

//     $(this).siblings().removeClass('active');
//     $(this).addClass('active');
// });

/*******************************************/
//Share dropdown - on video popups

$('.js-share').on('click', '.js-trigger', function() {
    $(this).parent('.js-share').toggleClass('open');
});

/*******************************************/
//Form Custom Select

$('.js-select-btn').on('click', function() {
    $(this).siblings('.js-form-select').focus();
});

$('.js-form-image-changer select').on('change', function(){
    var selected = $(this).find(':selected'),
    target = selected.data('vehicle');

    $('.js-form-image-handler').children('img').hide();
    $('.js-form-image-handler').find('[data-vehicle="' + target + '"]').show();
});

$('.js-form-dealer-select select').on('focus change', function(){
    var selected = $(this).find(':selected');
    var text = '';
    if (selected.length) {
      if (selected.data('dealer') != null) {
        text = selected.data('dealer').split('/').join('<br>');
      }
    }

    $('.js-form-dealer-details p').html(text);
});

var setVisibilityOfReadMoreToggles = function () {
    setTimeout(function () {
        $('.read-more-toggle').each(function (index) {
            console.log(index + ' : ' + $(this).parent().find('.read-moreable').prop('scrollHeight'));
            if ($(this).parent().find('.read-moreable').prop('scrollHeight') < 82) {
                $(this).hide();
            } else {
                $(this).show();
            }
        });
    }, 0);
};

var initialiseVisibleColourSlideshow = function () {
    setTimeout(function () {
        $('.model-tab .colours-slideshow.slick-slider').slick('unslick');

        $('.model-tab.active .colours-slideshow').slick({
            infinite: true,
            arrows: false,
            fade: true,
            dots: false,
            speed: 200,
            autoplay: true,
            autoplaySpeed: 20000,
            slidesToShow: 1,
            slidesToScroll: 1
        });

        $('.model-tab.active .js-slide-to').click(function(e) {
            e.preventDefault();
            var slideno = $(this).data('slide');
            $('.model-tab.active .colours-slideshow').slick('slickGoTo', slideno - 1);
        });

        $('.model-tab.active .colours-slideshow').on('afterChange', function(event, slick, currentSlide, nextSlide){
            var num = currentSlide+1;
            $('.model-tab.active .js-slide-to').removeClass('active');
            $('.model-tab.active .dot-' + num).addClass('active');
        });
    }, 100);
}

$(document).on('click', '.model-selector', function () {
    var index = $(this).data('index');
    $('.model-tab').hide().removeClass('active');
    $('.model-selector').removeClass('active');
    $(this).addClass('active');
    $('#model-tab-' + index).show({
        complete: function () {
            setTimeout(function () {
                setVisibilityOfReadMoreToggles();
                initialiseVisibleColourSlideshow();
            }, 0);
        },
    }).addClass('active');
});

$('.read-more-toggle').on('click', function () {
    $(this).parent().find('.read-moreable').toggleClass('reading-less');
    $(this).toggleClass('read-more-toggled');
    $(this).text($(this).hasClass('read-more-toggled') ? 'Hide' : 'Read more');
});

// hide/show read-more toggles depending on normal height
$(document).ready(function () {
    setVisibilityOfReadMoreToggles();
    initialiseVisibleColourSlideshow();
});